import TransactedCard from "../page_components/transacted_documents/transacted_card";
import TransactedTable from "../page_components/transacted_documents/transacted_table";

const TransactedDocuments = () => {




    return (
         
                <div className="container-xxl flex-grow-1 container-p-y">
                    <h4 className="py-3 mb-4"><span className="text-muted fw-light">Transacted Documents</span></h4>
                    
                  <TransactedCard/>
                  <TransactedTable />
                </div>
       
    );
}

export default TransactedDocuments;